import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './uilt/flexible.js'
import ElementUI from 'element-ui';
import Vant from 'vant';
import 'vant/lib/index.css';
import {url} from './uilt/intercept.js'
import 'element-ui/lib/theme-chalk/index.css';
Vue.config.productionTip = false
Vue.prototype.$url=url
Vue.use(ElementUI);
Vue.use(Vant);



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
